import React from "react";

import Box from "./Box";
import styles from "./RichText.module.scss";

function RichText({ children, style, ...props }) {
  return (
    <Box
      className={styles.richText}
      style={style}
      dangerouslySetInnerHTML={{ __html: children }}
      {...props}
    ></Box>
  );
}

export default RichText;
